import TitleWithFacets from './TitleWithFacets';

export default TitleWithFacets;
